import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { RoleGuard } from '@/components/auth/RoleGuard'
import { LoginForm } from '@/components/auth/LoginForm'
import { SignupForm } from '@/components/auth/SignupForm'
import { AppShell } from '@/components/layout/AppShell'
import { DashboardPage } from '@/features/dashboard/DashboardPage'
import { ProjectsListPage } from '@/features/projects/ProjectsListPage'
import { ProjectDetailPage } from '@/features/projects/ProjectDetailPage'
import { ProjectCreateForm } from '@/features/projects/ProjectCreateForm'
import { CatalogPage } from '@/features/catalog/CatalogPage'
import { ProductDetailPage } from '@/features/catalog/ProductDetailPage'
import { Configurator } from '@/features/catalog/Configurator'
import { QuotesListPage } from '@/features/quotes/QuotesListPage'
import { QuoteCreatePage } from '@/features/quotes/QuoteCreatePage'
import { QuoteDetailPage } from '@/features/quotes/QuoteDetailPage'
import { OrdersListPage } from '@/features/orders/OrdersListPage'
import { OrderDetailPage } from '@/features/orders/OrderDetailPage'
import { AdminLayout } from '@/admin/AdminLayout'
import { AnalyticsDashboardPage } from '@/admin/analytics/AnalyticsDashboardPage'
import { UsersListPage } from '@/admin/users/UsersListPage'
import { AdminCatalogPage } from '@/admin/catalog/AdminCatalogPage'
import { SettingsPage } from '@/admin/settings/SettingsPage'
import { ApplicationsPage } from '@/admin/applications/ApplicationsPage'
import { AdminOrdersListPage } from '@/admin/orders/AdminOrdersListPage'
import { AdminOrderDetailPage } from '@/admin/orders/AdminOrderDetailPage'
import { AdminOrganizationsPage } from '@/admin/organizations/AdminOrganizationsPage'
import { AdminOrganizationDetailPage } from '@/admin/organizations/AdminOrganizationDetailPage'
import { AdminQuotesListPage } from '@/admin/quotes/AdminQuotesListPage'
import { AdminQuoteDetailPage } from '@/admin/quotes/AdminQuoteDetailPage'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Auth routes */}
          <Route path="/gaviota/login" element={<LoginForm />} />
          <Route path="/gaviota/signup" element={<SignupForm />} />

          {/* Vendor Portal */}
          <Route path="/gaviota" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="projects" element={<ProjectsListPage />} />
            <Route path="projects/new" element={<ProjectCreateForm />} />
            <Route path="projects/:id" element={<ProjectDetailPage />} />
            <Route path="catalog" element={<CatalogPage />} />
            <Route path="catalog/:productId" element={<ProductDetailPage />} />
            <Route path="catalog/:productId/configure" element={<Configurator />} />
            <Route path="quotes" element={<QuotesListPage />} />
            <Route path="quotes/new" element={<QuoteCreatePage />} />
            <Route path="quotes/:id" element={<QuoteDetailPage />} />
            <Route path="orders" element={<OrdersListPage />} />
            <Route path="orders/:id" element={<OrderDetailPage />} />
          </Route>

          {/* Admin Dashboard */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <RoleGuard allowedRoles={['keder_admin']}>
                <AdminLayout />
              </RoleGuard>
            </ProtectedRoute>
          }>
            <Route index element={<AnalyticsDashboardPage />} />
            <Route path="applications" element={<ApplicationsPage />} />
            <Route path="orders" element={<AdminOrdersListPage />} />
            <Route path="orders/:id" element={<AdminOrderDetailPage />} />
            <Route path="quotes" element={<AdminQuotesListPage />} />
            <Route path="quotes/:id" element={<AdminQuoteDetailPage />} />
            <Route path="organizations" element={<AdminOrganizationsPage />} />
            <Route path="organizations/:id" element={<AdminOrganizationDetailPage />} />
            <Route path="users" element={<UsersListPage />} />
            <Route path="catalog" element={<AdminCatalogPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/gaviota" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
